import { List } from 'immutable';
import ActionInput from 'automation-ui-action-features/action-inputs/records/ActionInput';
import QueryParam from 'automation-ui-action-features/action-inputs/records/QueryParam';
import * as WebhookActionMetadataKeys from 'automation-ui-action-features/actions/webhook/constants/WebhookActionMetadataKeys';
export const formatQueryParamVariables = queryParameters => {
  if (!queryParameters) return null;
  const variables = queryParameters.variables;
  if (!variables) return null;
  return new QueryParam({
    [WebhookActionMetadataKeys.VARIABLES]: List(variables.map(queryParam => new ActionInput(queryParam)))
  });
};